import React, { useEffect, useState } from 'react'
import tw, { styled } from 'twin.macro'
import Button, { ButtonSize, ButtonVariant } from '@components/DesignSystem/Button'
import useDynamicLinkForDownloadApp from '@hooks/useDynamicLinkForDownloadApp'
import { trackBottomAppPromotionBannerEvent } from '@libs/eventTracking/article'
import { trackIntersectionDownloadAppEvent } from '@libs/eventTracking/downloadBar/intersection.download-app'
import CloseIcon from '../../../components/Icons/CloseIcon'

const DownloadAppBanner = (props) => {
  const {
    openWebLink = undefined,
    isNeedCloseIcon = false,
    isArticlePage = false,
    slogan,
    buttonText,
  } = props

  const openAppLink = useDynamicLinkForDownloadApp(openWebLink)

  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (isArticlePage) {
      const isNeedHideBanner = document.cookie.includes('hideDownloadAppBanner')
      setIsVisible(!isNeedHideBanner)
    }
  }, [])

  const trackEvent = () => {
    const trackEvent = isArticlePage
      ? trackBottomAppPromotionBannerEvent
      : trackIntersectionDownloadAppEvent
    trackEvent(window.location.href, slogan, openAppLink)
  }

  if (!isVisible) {
    return null
  }

  return (
    <Overlay>
      {isNeedCloseIcon && (
        <CloseButton
          onClick={() => {
            setIsVisible(false)
            document.cookie = 'hideDownloadAppBanner=;max-age=172800;path=/'
          }}
        >
          <CloseIcon width="14" height="14" />
        </CloseButton>
      )}
      <Slogan>{slogan}</Slogan>
      <Rating>
        <img src="/statics/images/rate-stars.svg" alt="rate-stars" />
        4.7 (2,705)
      </Rating>
      <StyledButton
        size={ButtonSize.large}
        variant={ButtonVariant.primary}
        as="a"
        href={openAppLink}
        onClick={() => trackEvent()}
      >
        {buttonText}
      </StyledButton>
    </Overlay>
  )
}

export default DownloadAppBanner

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0px, #ffffff 91px);
  padding: 98px 16px 16px;
`

const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  padding: 3px;
  position: absolute;
  top: 98px;
  left: 16px;
  color: #414141;
  border-radius: 50%;
  margin: 0;
  background: #eeeeee;
`

const Slogan = styled.div`
  ${tw`text-primary-darkGrey`};
  font-weight: 500;
  line-height: 1;
`

const Rating = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0 16px;

  img {
    margin-right: 5px;
  }
`

const StyledButton = styled(Button)`
  ${tw`w-full`};
  height: 56px;
  background: linear-gradient(270deg, #b366ff 0%, #6666ff 100%);
`
